import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Users02 = function Users02(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props, {
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#fff",
      fillOpacity: 0.01,
      d: "M9.75 11.1c2.2368 0 4.05-1.8133 4.05-4.05S11.9868 3 9.75 3C7.5133 3 5.7 4.8133 5.7 7.05s1.8133 4.05 4.05 4.05Z"
    }), /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M15.6 3.421c1.3335.6627 2.25 2.0388 2.25 3.629 0 1.5902-.9165 2.9663-2.25 3.629m1.8 4.7107c1.3603.6156 2.5853 1.6188 3.6 2.9103m-18 0c1.7518-2.2297 4.1303-3.6 6.75-3.6s4.9982 1.3703 6.75 3.6M13.8 7.05c0 2.2367-1.8132 4.05-4.05 4.05-2.2367 0-4.05-1.8133-4.05-4.05S7.5133 3 9.75 3c2.2368 0 4.05 1.8133 4.05 4.05Z"
    })]
  }));
};
export default Users02;